<script setup lang="ts">
import type { KirbyBlock } from "#nuxt-kirby";
import type { ComponentPublicInstance } from "vue";

import {
  LazyKirbyBlockAccordion,
  LazyKirbyBlockBestHikesTable,
  LazyKirbyBlockButton,
  LazyKirbyBlockGallery,
  LazyKirbyBlockHeading,
  LazyKirbyBlockImage,
  LazyKirbyBlockLine,
  LazyKirbyBlockList,
  LazyKirbyBlockQuote,
  LazyKirbyBlockSelfGuidedTrekPackageInfo,
  LazyKirbyBlockText,
  LazyKirbyBlockTrekFaqs,
  LazyKirbyBlockTrekItinerary,
  LazyKirbyBlockTrekMap,
  LazyKirbyBlockTrekPackageInfo,
  LazyKirbyBlockVideo,
  LazyKirbyBlockVideoPopup,
} from "#components";

defineProps<{
  blocks: KirbyBlock<string>[];
}>();

type ComponentConstructor = new (...args: any[]) => ComponentPublicInstance;

const blockComponents: Record<string, ComponentConstructor> = {
  accordion: LazyKirbyBlockAccordion,
  besthikestable: LazyKirbyBlockBestHikesTable,
  button: LazyKirbyBlockButton,
  heading: LazyKirbyBlockHeading,
  image: LazyKirbyBlockImage,
  line: LazyKirbyBlockLine,
  list: LazyKirbyBlockList,
  quote: LazyKirbyBlockQuote,
  text: LazyKirbyBlockText,
  trekfaqs: LazyKirbyBlockTrekFaqs,
  trekitinerary: LazyKirbyBlockTrekItinerary,
  trekmap: LazyKirbyBlockTrekMap,
  trekpackageinfo: LazyKirbyBlockTrekPackageInfo,
  selfguidedtrekpackageinfo: LazyKirbyBlockSelfGuidedTrekPackageInfo,
  gallery: LazyKirbyBlockGallery,
  video: LazyKirbyBlockVideo,
  videopopup: LazyKirbyBlockVideoPopup,
};
</script>

<template>
  <div v-router-links>
    <template v-for="(block, index) in blocks" :key="index">
      <component :is="blockComponents[block.type]" :block="block" />
    </template>
  </div>
</template>
